// Library
import React, { useState, useEffect, useContext } from 'react'
// npm install @emotion/core and npm install @emotion/styled
import { Segment, Container, Dimmer, Loader, Message } from 'semantic-ui-react'
// import theme from 'assets/pictures/theme'
import Spacer from 'components/atoms/Spacer'
import paths from 'constants/paths'
import { auth } from 'FirebaseConfig'
import { AuthContext } from 'providers/Auth'
import NavigationBarPlane from 'components/organisms/menubar/NavigationBarPlane'
import { useHistory } from 'react-router-dom'
import SignInForm from 'components/organisms/sessions/SignInForm'
import FooterNav from 'components/organisms/menubar/FooterNav'

const SigninAdmin = () => {
  // currentUser is provided
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const history = useHistory()
  const { currentUser } = useContext(AuthContext)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState({})
  const [visible, setVisible] = useState(false)

  // styledでcssかいたらhandleChangeのたびに再レンダーされるのでinputには向いてない。解決方法あるか。
  const handleChange = (event) => {
    switch (event.target.name) {
      case 'email':
        setEmail(event.target.value)
        break
      case 'password':
        setPassword(event.target.value)
        break
      default:
        console.log('key not found')
    }
  }

  const clickLoginAsAdmin = () => {
    setLoading(true)
    auth
      .signInWithEmailAndPassword(email, password)
      .then((res) => {
        if (res.user.emailVerified) {
          history.push({
            pathname: `${paths.adminConsole}`,
            state: {
              text: '',
              type: 'positive',
            },
          })
          setLoading(false)
        } else {
          setMessage({
            type: 'negative',
            title: '管理者ログインエラー',
            text: 'メール認証が終わっていません',
          })
          setVisible(true)
        }
      })
      .catch((error) => {
        setLoading(false)
        setVisible(true)
        setMessage({
          type: 'negative',
          title: 'Error',
          text: error.message,
        })
      })
  }

  useEffect(() => {
    if (currentUser) {
      history.push({
        pathname: `${paths.adminConsole}`,
        state: {
          text: 'ログインしました。',
          type: 'positive',
        },
      })
    }
  }, [currentUser, history]) //TODO: これでいいの？フラグの判定はしなくて良い？

  const handleDismiss = () => {
    setVisible(false)
    history.push({
      state: { text: '', type: '' },
    })
  }

  return (
    <>
      <NavigationBarPlane />
      <Spacer />
      {loading && (
        <Dimmer active inverted>
          <Loader size="massive">Loading</Loader>
        </Dimmer>
      )}
      <Container text>
        <Segment>
          <div className="signin__loginFormContainer">
            <SignInForm
              header="AdVice for Adminにログインする"
              note="管理者画面へのログイン"
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              clickLogin={clickLoginAsAdmin}
              handleChange={handleChange}
              owner={true}
            />
          </div>
        </Segment>
      </Container>
      <Spacer />
      {visible && (
        <div className="appLayoutMessage">
          <Message negative onDismiss={handleDismiss} header={message.title} content={message.text} />
        </div>
      )}
      <FooterNav />
    </>
  )
}

export default SigninAdmin
